function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 157.96 136.77"
}, props), React.createElement("g", {
  stroke: "currentColor",
  strokeMiterlimit: "10"
}, React.createElement("rect", {
  width: "153.46",
  height: "88.57",
  x: "2.25",
  y: "45.95",
  fill: "none",
  strokeWidth: "4.5",
  rx: "6.17",
  ry: "6.17"
}), React.createElement("circle", {
  cx: "78.98",
  cy: "91.95",
  r: "31.17",
  fill: "currentColor",
  transform: "rotate(-45 78.98 91.94)"
}), React.createElement("circle", {
  cx: "78.98",
  cy: "91.95",
  r: "24.72",
  fill: "#fff"
}), React.createElement("circle", {
  cx: "78.98",
  cy: "91.95",
  r: "18.84",
  fill: "none",
  strokeWidth: "4.5"
}), React.createElement("path", {
  fill: "none",
  strokeWidth: "4.5",
  d: "M122.5 56.76h20.86v10.47H122.5zm-99.64-30.9H49.9v20.08H22.86z"
}), React.createElement("path", {
  fill: "currentColor",
  d: "M31.87 33.17a1.68 1.68 0 1 1-1.67-1.67 1.68 1.68 0 0 1 1.67 1.67zm6.18 0a1.68 1.68 0 1 1-1.67-1.67 1.68 1.68 0 0 1 1.67 1.67zm6.18 0a1.68 1.68 0 1 1-1.67-1.67 1.68 1.68 0 0 1 1.67 1.67zm0 6.18a1.68 1.68 0 1 1-1.67-1.67 1.68 1.68 0 0 1 1.67 1.67zm-6.18 0a1.68 1.68 0 1 1-1.67-1.67 1.68 1.68 0 0 1 1.67 1.67zm-6.18 0a1.68 1.68 0 1 1-1.67-1.67 1.68 1.68 0 0 1 1.67 1.67z"
}), React.createElement("path", {
  fill: "none",
  strokeLinecap: "round",
  strokeWidth: "5",
  d: "M37.31 2.5v11"
}), React.createElement("path", {
  fill: "none",
  strokeLinecap: "round",
  strokeWidth: "4.5",
  d: "M13.74 8.8l7.42 7.87M58.79 8.9l-7.62 7.67M23.89 46s17 37.07 0 88.57"
}))));